import { addDoc, collection, deleteDoc, doc, getDocs } from "firebase/firestore";
import { db, getSiteKey } from "../firebaseConfig";
import { FireStoreOperator, Operator } from "../model/OperatorModel";
import { getAuth } from "firebase/auth";

export const StoreOperatorGateway = {
    Get: async () => {
        const snapshot = await getDocs(collection(db, 'storeOperators'));
        const list: FireStoreOperator[] = snapshot.docs.map((docSnap) => ({
            id: docSnap.id,
            operator: (docSnap.data() as Omit<Operator, 'id'>),
        }));

        return list;
    },
    Save: async (operator: Operator) => {
        const auth = getAuth();
        const user = auth.currentUser;
        if (!user) throw new Error('User not authenticated');

        const idToken = await user.getIdToken();
        const clientKey = getSiteKey();

        const response = await fetch(`${process.env.REACT_APP_MESSAGE_API_HOST}/registerStoreOperator`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                Authorization: `Bearer ${idToken}`,
                'x-client-key': clientKey,
            },
            body: JSON.stringify(operator),
        });

        if (!response.ok) {
            const contentType = response.headers.get('Content-Type');
            let errorMessage = `Request failed with status ${response.status}`;

            if (contentType && contentType.includes('application/json')) {
                const errorData = await response.json();
                errorMessage = errorData.message || errorMessage;
            }
            console.error("Failed to call /registerStoreOperator", response)
            throw new Error(errorMessage);
        }

        // Save metadata to Firestore
        await addDoc(collection(db, 'storeOperators'), {
            firstName: operator.firstName,
            lastName: operator.lastName,
            email: operator.email,
        });
    },
    Delete: async (id: string) => {

        await deleteDoc(doc(db, 'storeOperators', id));

        return true;
    },
}